import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/admin-settings/organisation")({
  component: Outlet,
})
